import { BadgeTier, getBadgeTierForBlocks } from "@bbb/model";
import { BADGE_TIERS } from "@constants";
import { BadgeTierUI } from "@types";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatError(err: unknown): string {
  try {
    if (!(err instanceof Error)) {
      return `Non-error thrown: ${JSON.stringify(err)}`;
    }
    // Keep only the first few *useful* frames (app code, not node_modules)
    const stackLines = err.stack?.split("\n") ?? [];
    const trimmedStack = stackLines.slice(0, 2).join("\n"); // top 3 frames
    return `${err.message}:::${(err as any).cause ?? "none"}:::${trimmedStack}`;
  } catch {
    return `Unformattable error!`;
  }
}

export function determineBadgeTier(blocks: number): BadgeTier {
  return getUserBadgeTier(blocks).name;
}

export function getUserBadgeTier(blocks: number): BadgeTierUI {
  const tierName = getBadgeTierForBlocks(blocks) ?? BADGE_TIERS[0]!.name;
  return BADGE_TIERS.find((tier) => tier.name === tierName) ?? BADGE_TIERS[0]!;
}

// URL validation function
export const isValidUrl = (urlString: string): boolean => {
  if (!urlString || urlString.trim() === "") return true; // Empty is valid (optional field)

  try {
    const url = new URL(urlString);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};
